import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-agile',
  standalone: true,
  imports: [],
  templateUrl: './agile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agile.component.scss'
})
export class AgileComponent {

}
